module.exports = __webpack_public_path__ + "static/media/check.3a844cc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityCard/check.svg
// module id = 303
// module chunks = 0